import { getPasscode } from './util'
import config from '../../config'

export const fetchPortal = id =>
  fetch(config.apiEndpoint + `/portal/${id}`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
    },
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => result.data)

export const updatePortal = portal =>
  fetch(config.apiEndpoint + `/portal/${portal._id}`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: portal }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => result.data)

export const sendMessageToTopic = (portalId, topics, notification) =>
  fetch(config.apiEndpoint + `/portal/${portalId}/send_notification`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      data: {
        topics,
        notification,
      },
    }),
  })

export const requestDynamicLink = portalId =>
  fetch(config.apiEndpoint + `/portal/${portalId}/link`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.result === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })

export const requestCreateDynamicLink = portalId =>
  fetch(config.apiEndpoint + `/portal/${portalId}/link`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.result === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })



// WEBPACK FOOTER //
// ./src/modules/portal-remote/portalService.js